import { Controller } from "@hotwired/stimulus"
import axios from 'axios';
import getFriendlyErrorMessage from '../../javascript/helpers/getFriendlyErrorMessage';

import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";

export default class extends Controller {
  rootLogs = null;

  async onSubmit(event) {
    event.preventDefault()
    event.stopImmediatePropagation();

    const form = document.getElementById('form-exportar-dados');
    const formData = new FormData(form);

    try {
      this.hideErrors();
      showModalCarregando('Processando... Por favor aguarde, essa operação pode levar alguns minutos.');
      const response = await axios.post(form.action, formData, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));

      const link = document.createElement('a');
      link.href = url;

      const nomeArquivo = `relatorios-sgf-${this.getDataHoraAtual()}.xlsx`;

      link.setAttribute('download', nomeArquivo);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      const message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
      this.showErrors(message);
    } finally {
      hideModalCarregando();
    }
  }


  showErrors(message) {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = message;
    container.style.display = '';
  }

  hideErrors() {
    const container = document.getElementById('error-message-container');
    const errorMessage = document.getElementById('error-message');
    errorMessage.innerHTML = '';
    container.style.display = 'none';
  }

  getDataHoraAtual() {
    // Não consegui formatar a data do jeito que preciso usando funções pré-existentes do JS, então tive que criar a minha - bruno
    // Fonte: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts
    const options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    };

    const dataHora = new Intl.DateTimeFormat('pt-BR', options).formatToParts(new Date()).map((p) => p.value);
    
    // formato: ano-mes-dia--hora-minuto-segundo
    return dataHora[4]+'-'+dataHora[2]+'-'+dataHora[0]+'--'+dataHora[6]+'-'+dataHora[8]+'-'+dataHora[10]
  }
}